import React, { useEffect, useState } from 'react';

import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';

import { TydeMenuItem } from '../menu-item';

import './tyde-side-menu.scss';
import { TydeSideMenuProps } from './TydeSideMenuProps';

export function TydeSideMenu(props: TydeSideMenuProps) {
  const [menuState, setMenuState] = useState({ expanded: false });

  useEffect(() => {
    if (props.onToggle) {
      props.onToggle(menuState.expanded);
    }
  }, [menuState.expanded]);

  const renderMenuItems = () => {
    return props.menuItems.map((item, index) => {
      let className = 'item';

      if (menuState.expanded) {
        className += ' expanded';
      }

      return <TydeMenuItem key={index} className={className} item={item} menuState={menuState} />;
    });
  };

  let menuClassName = 'tyde-side-menu menu';

  if (menuState.expanded) {
    menuClassName += ' expanded';
  }

  const menuButtonClickHandler = () => {
    setMenuState((prevState) => {
      return {
        expanded: !prevState.expanded,
      };
    });
  };

  return (
    <div className={menuClassName}>
      <div className="content">
        <div className="logo" />
        <div className="items">{renderMenuItems()}</div>
      </div>
      <div className="side">
        <IconButton onClick={menuButtonClickHandler}>
          <MenuIcon color={'primary'} fontSize={'large'} />
        </IconButton>
      </div>
    </div>
  );
}
